import BaseService from "@/services/baseService";

export default class UtilService extends BaseService {
    static async Vocabolario() {
        return await this.perfom({
            url: "/api/v2.0/appecupt/urlserviziapp/vocabolario",
            method: "GET"
        });
    }
    static async listaProvince() {
        return await this.perfom({
            url: "/api/v2.0/appecupt/comuni/listaprovince",
            method: "GET",
            headers: {}
        });
    }
    static async listaComuni(istatProvincia) {
        return await this.perfom({
            url: "/api/v2.0/appecupt/comuni/listacomuni",
            method: "POST",
            headers: {},
            body: {
                codIstat: istatProvincia
            }
        });
    }

    static async listaNazioni() {
        return await this.perfom({
            url: "/api/v2.0/appecupt/nazioni",
            method: "GET",
            headers: {}
        });
    }

    static async statoCivile() {
        return await this.perfom({
            url: "/api/v2.0/appecupt/statocivile",
            method: "GET",
            headers: {}
        });
    }

    static async faq(){
        return await this.perfom({
            url: "/api/v2.0/faq",
            method: "GET",
            headers: {}
        });
    }

    static async supportoMail(parametriSupporto){
        return await this.perfom({
            url: "/urlserviziapp/emailAssistenza",
            method: "POST",
            headers: {},
            body: parametriSupporto
        });
    }
}
